import React, { Component } from 'react';
import AccessContainer from '../../access/AccessContainer';
import { RootState } from '../../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { AccessBase } from '../../../domain/access/BaseAccess';
import RoleHelper from '../../../RoleHelper';
import { changeAiModel } from '../../../redux/actions/AiModelActions';
import ComponentName from '../../../constant/ComponentName';

class AiModelAccessComponent extends Component<Props, State> {
  public render() {
    const {
      aiModel: { aiModel },
    } = this.props;
    const access: AccessBase = { permission: aiModel.permission, collaborators: aiModel.collaborators };
    return (
      <div className={'flex w-full h-full'}>
        <AccessContainer access={access} changeAccess={this.changeAccess} disabled={!RoleHelper.canManage(ComponentName.AI_MODEL)} />
      </div>
    );
  }

  private changeAccess = (access: AccessBase) => {
    const {
      changeAiModel,
      aiModel: { aiModel },
    } = this.props;
    aiModel.permission = access.permission;
    aiModel.collaborators = access.collaborators;
    changeAiModel(aiModel);
  };
}

interface Props extends ReduxProps {}

class State {}

const mapStateToProps = (state: RootState) => ({
  aiModel: state.aiModel,
});
const mapDispatchToProps = { changeAiModel };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(AiModelAccessComponent);
